import { cn } from "@stacklet/ui";

import { Link } from "app/components/links/Link";

const CURRENT_YEAR = new Date().getFullYear();

interface Props {
  className?: string;
}

export function Copyright({ className }: Props) {
  return (
    <p className={cn("text-body-medium", className)} data-testid="copyright">
      {"Copyright © "}
      <Link href="https://stacklet.io">Stacklet</Link>
      {` ${CURRENT_YEAR}.`}
    </p>
  );
}
